export { default as HeroWithConfetti } from './HeroWithConfetti';
